import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {RssTypeCode} from '../../../constants/rssTypeCode-Constans';
import {RemittancePurposeTypeCode} from '../../../constants/remittancePurposeTypeCode-Constans';
import {RSSRemitEntityValue} from '../../../model/rSSRemitEntityValue';
import {Constants} from '../../../constants/ebtq-constants';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../services/api.service';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {RSSRemitWrapper} from '../../../model/rSSRemitWrapper';
import {UtilityService} from '../../../services/utility-service';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-rsstransactions',
  templateUrl: './rsstransactions.component.html',
  styleUrls: ['./rsstransactions.component.scss']
})
export class RSSTransactionsComponent implements OnInit {

  transType: any[];
  selectedType: string;
  lnNumber = '';
  selNumber: number;
  lnAmount: number;
  remitCode = '';
  transactionType = '';
  remittancePurposeTypeCode = null;
  containsError = false;
  errorMsg: string;
  rssSuccMess: string;
  displayMess = false;
  displyRssTbl = true;
  utilService: UtilityService;
  title = 'RSS Transactions';

  searchForm = new UntypedFormGroup({
    lnNumber: new UntypedFormControl(''),
    selNumber: new UntypedFormControl(''),
    lnAmount: new UntypedFormControl('')
  });

  constructor(private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {
    this.displayMess = false;
    this.displyRssTbl = true;
    this.utilService = new UtilityService();
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    // load select box
    this.transType = [];
    this.transType.push({label: 'Post Purchase Adj. - Increase', value: RssTypeCode.POST_PURCHASE_ADJ_INC});
    this.transType.push({label: 'Post Purchase Adj. - Decrease', value: RssTypeCode.POST_PURCHASE_ADJ_DEC});
    this.selectedType = RssTypeCode.POST_PURCHASE_ADJ_INC;
  }

  validateInput() {
    let valid = true;

    if (this.lnNumber === null || this.lnNumber === undefined || this.lnNumber === '')
    {
      valid = false;
    }

    if (this.selNumber === null || this.selNumber === undefined || this.selNumber.toString() === '')
    {
      valid = false;
    }

    if (this.lnAmount === null || this.lnAmount === undefined || this.lnAmount.toString() === '')
    {
      valid = false;
    }

    return valid;
  }

  clearBtn() {
    this.searchForm.reset();
    this.searchForm.value.lnNumber = '';
    this.searchForm.value.selNumber = null;
    this.searchForm.value.lnAmount = null;
  }

  saveBtn() {
    this.lnNumber = this.searchForm.value.lnNumber;
    this.selNumber = this.searchForm.value.selNumber;
    this.lnAmount = this.searchForm.value.lnAmount;

    if (this.validateInput())
    {
      // If the transaction type is post purchase adjustment increase
      // then set the remit code to 01
      if (this.selectedType === RssTypeCode.POST_PURCHASE_ADJ_INC)
      {
        this.transactionType = RssTypeCode.POST_PURCHASE_REMT_CD;
        this.remitCode = RssTypeCode.NEGATIVE_TRAN_CODE;
        this.remittancePurposeTypeCode = RemittancePurposeTypeCode.PURCHASE_ADJUSTMENTS_CODE;
      }

      // If the transaction type is post purchase adjustment decrease
      // then set the remit code to 01
      else if (this.selectedType === RssTypeCode.POST_PURCHASE_ADJ_DEC)
      {
        this.transactionType = RssTypeCode.POST_PURCHASE_REMT_CD;
        this.remitCode = RssTypeCode.POSITIVE_TRAN_CODE;
        this.remittancePurposeTypeCode = RemittancePurposeTypeCode.PURCHASE_ADJUSTMENTS_CODE;
      }

      const rssWrapper = new RSSRemitWrapper();
      const request = new RSSRemitEntityValue();

      request.fnmLnNo = this.lnNumber;
      request.fnmSsnNo = this.selNumber;
      request.rmttAmt = this.lnAmount;
      request.rmttTypCd = this.transactionType;
      request.rssRmttCd = this.remitCode;
      request.rssSntToFlag = 'N';
      request.prdctTypCd = ' ';
      request.rmttPurpsTypCd = this.remittancePurposeTypeCode;
      request.lstUpdUsrId = Constants.SYSTEM_USER;
      request.recCrtrUsrId = Constants.SYSTEM_USER;

      rssWrapper.value = request;
      this.apiService.insertRSSEntry(rssWrapper)
        .subscribe((data: any) => {
          this.displayMess = true;
          this.displyRssTbl = false;
          if (data === 1) {
            this.rssSuccMess = Constants.RSS_SUCCESS_MESS;
          } else {
            this.rssSuccMess = Constants.RSS_FAIL_MESS;
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });
      this.errorAnnouncement();
    }

    else
    {
      this.rssSuccMess = Constants.RSS_FAIL_MESS;
      this.errorMsg = this.rssSuccMess;
      this.displayMess = true;
    }

    this.errorAnnouncement();
  }

  errorAnnouncement() {
    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        if (message.includes('insert RSS records')) {
          this.rssSuccMess = Constants.RSS_FAIL_MESS;
          this.displayMess = true;
          this.displyRssTbl = false;
        } else {
          this.errorMsg = message;
          this.containsError = true;
        }
        this.cdr.detectChanges();
      });
  }


}
